import { howIRequestExtraPickUpDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const gethowIRequestExtraPickUpEn = () => {
  const data = howIRequestExtraPickUpDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addhowIRequestExtraPickUp = () => {
  if (
    window.location.href.includes(
      `us/en/support/faqs/how-do-i-request-an-extra-pickup`,
    ) &&
    document.getElementById(`howIRequestExtraPickUpJSONLD`) === null
  ) {
    const script = HowIRequestExtraPickUpJSONLDEn()
    addJSONLDToHead(script, `howIRequestExtraPickUpJSONLD`)
  } else {
    removeElement(`howIRequestExtraPickUpJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const HowIRequestExtraPickUpJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: gethowIRequestExtraPickUpEn(),
  }
  return FaqBagsterTemplate
}
